<template>
  <div
    ref="cell"
    class="grid-view__cell grid-field-geo-data__cell active"
    :class="{ editing }"
    @contextmenu="stopContextIfEditing($event)"
  >
    <div class="grid-field-geo-data" @click="toggleMap()">
      <i class="iconoir-pin-alt grid-field-geo-data__icon"></i>
      <span class="grid-field-geo-data__text">
        {{ displayValue }}
      </span>
    </div>
    <Context
      ref="mapContext"
      class="grid-field-geo-data__context"
      @shown="editing = true"
      @hidden="editing = false"
    >
      <LeafletMapView
        :pickable="true"
        :read-only="readOnly"
        :value="value"
        class="grid-field-geo-data__map"
        @picked="pick($event)"
      />
    </Context>
  </div>
</template>

<script>
import gridField from '@baserow/modules/database/mixins/gridField'
import LeafletMapView from '@baserow/modules/database/components/map/LeafletMapView'

export default {
  name: 'GridViewFieldGeoData',
  components: { LeafletMapView },
  mixins: [gridField],
  emits: ['update'],
  data() {
    return {
      editing: false,
    }
  },
  computed: {
    displayValue() {
      // Mirrors the fieldType's isEmpty/getEmptyValue notion of "no
      // location" so the cell and validation stay in sync.
      if (!this.value || this.value.lat == null || this.value.lng == null) {
        return this.$t('gridViewFieldGeoData.noLocation')
      }
      return `${this.value.lat}, ${this.value.lng}`
    },
  },
  methods: {
    toggleMap() {
      // Opening the map is viewing, always allowed; `readOnly` only
      // suppresses the pick/drag/search affordances inside it (threaded
      // through as a prop below), the same split `GridViewFieldFile` draws
      // between opening a file and uploading a new one.
      this.$refs.mapContext.toggle(this.$refs.cell, 'bottom', 'left', 4)
    },
    pick(latLng) {
      this.$emit('update', latLng, this.value)
    },
    // Called by the grid when the cell is unselected; closing here keeps the
    // popup from lingering after the user clicks elsewhere in the grid.
    beforeUnSelect() {
      this.$refs.mapContext.hide()
    },
  },
}
</script>
